import { useState } from 'react';

import nodejs from "../assets/skills/nodejs.svg";
import bash from "../assets/skills/bash.svg";
import gcp from "../assets/skills/gcp.svg";
import linux from "../assets/skills/linux.svg";
import python from "../assets/skills/python.svg";
import azure from "../assets/skills/azure.svg";
import datadog from "../assets/skills/datadog.svg";
import grafana from "../assets/skills/grafana.svg";
import kubernetes from "../assets/skills/kubernetes.svg";
import ansible from "../assets/skills/ansible.svg";
import helm from "../assets/skills/helm.svg";
import jenkins from "../assets/skills/jenkins.svg";
import newrelic from "../assets/skills/newrelic.svg";
import docker from "../assets/skills/docker.svg";
import git from "../assets/skills/git.svg";
import prometheus from "../assets/skills/prometheus.svg";
import gitlab from "../assets/skills/gitlab.svg";
import vault from "../assets/skills/vault.svg";
import terraform from "../assets/skills/terraform.svg";
import claude from "../assets/skills/claude.svg";

export default function Skills() {
  const [activeCategory, setActiveCategory] = useState("all");

  const categories = [
    { id: "all", label: "All Skills" },
    { id: "cloud", label: "Cloud Platforms" },
    { id: "containers", label: "Containers & K8s" },
    { id: "iac", label: "IaC & GitOps" },
    { id: "observability", label: "Observability & SRE" },
    { id: "security", label: "Security & Secrets" },
    { id: "ai", label: "AI & Platform Tools" },
    { id: "languages", label: "Languages & Scripting" },
  ];

  const skillsData = [
    { name: "Google Cloud (GCP)", category: "cloud", img: gcp, level: "Advanced / Architect" },
    { name: "Microsoft Azure", category: "cloud", img: azure, level: "Certified Associate" },
    { name: "Linux Administration", category: "cloud", img: linux, level: "Enterprise OS" },
    { name: "Kubernetes (GKE/AKS)", category: "containers", img: kubernetes, level: "Production Clusters" },
    { name: "Docker", category: "containers", img: docker, level: "Containerization" },
    { name: "Helm", category: "containers", img: helm, level: "Package Management" },
    { name: "HashiCorp Terraform", category: "iac", img: terraform, level: "Certified Associate" },
    { name: "Ansible", category: "iac", img: ansible, level: "Configuration Mgmt" },
    { name: "Jenkins", category: "iac", img: jenkins, level: "CI/CD Pipelines" },
    { name: "GitLab CI/CD", category: "iac", img: gitlab, level: "DevOps Pipelines" },
    { name: "Git & GitOps", category: "iac", img: git, level: "Version Control" },
    { name: "HashiCorp Vault", category: "security", img: vault, level: "Zero-Trust Secrets" },
    { name: "Prometheus", category: "observability", img: prometheus, level: "Metrics & Alerting" },
    { name: "Grafana", category: "observability", img: grafana, level: "Dashboards & SLOs" },
    { name: "Datadog", category: "observability", img: datadog, level: "Cloud Monitoring" },
    { name: "New Relic", category: "observability", img: newrelic, level: "Advanced Practitioner" },
    { name: "Claude Code", category: "ai", img: claude, level: "Agentic Engineering" },
    { name: "Python", category: "languages", img: python, level: "Automation & Scripting" },
    { name: "Bash / Shell", category: "languages", img: bash, level: "Systems Automation" },
    { name: "Node.js", category: "languages", img: nodejs, level: "Backend Tooling" },
  ];

  const filteredSkills = activeCategory === "all"
    ? skillsData
    : skillsData.filter(s => s.category === activeCategory);

  return (
    <section id="skills" className="py-16 md:py-24 text-white border-t border-zinc-800/80">
      {/* Section Header */}
      <div className="max-w-3xl mb-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-teal-500/10 text-teal-300 border border-teal-500/30 uppercase tracking-wider mb-3">
          Technical Arsenal
        </div>
        <h2 className="text-2xl sm:text-4xl font-extrabold tracking-tight text-white">
          Skills &amp; Technologies
        </h2>
        <p className="mt-2 text-base text-gray-400">
          Core toolsets and enterprise platforms leveraged across 14+ years of cloud architecture, site reliability, and automation engineering.
        </p>
      </div>

      {/* Category Filter Pills */}
      <div className="flex flex-wrap gap-2 mb-10">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => setActiveCategory(cat.id)}
            className={`px-4 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all duration-200 ${
              activeCategory === cat.id
                ? "bg-teal-500 text-dark-900 shadow-md shadow-teal-500/25"
                : "bg-dark-200/70 text-gray-300 hover:text-white hover:bg-dark-100 border border-zinc-800"
            }`}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Skills Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {filteredSkills.map((skill, idx) => (
          <div
            key={skill.name}
            className="flex flex-col items-center justify-center p-5 rounded-2xl bg-dark-200/50 border border-zinc-800/80 hover:border-teal-500/40 hover:bg-dark-200/80 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-teal-500/5 group text-center"
          >
            <div className="w-14 h-14 p-2 rounded-xl bg-dark-300/80 border border-zinc-700/50 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
              <img src={skill.img} alt={skill.name} className="w-10 h-10 object-contain" />
            </div>
            <h3 className="font-semibold text-sm sm:text-base text-white group-hover:text-teal-300 transition-colors">
              {skill.name}
            </h3>
            <span className="text-[11px] text-gray-400 mt-1">
              {skill.level}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}